module.exports = __webpack_public_path__ + "static/media/srstorelogo.604069b9.svg";